export default "__VITE_ASSET__DKs2MuKr__"